import React, { useEffect, useState, useRef } from "react";
import Papa from "papaparse";
import { Typography, BoldLink } from '../../components';
import { Container, AanmeldenContainer, MapContainer } from './styled';

import zorgkaart from '../../assets/images/ouders/zorgkaart.png';

export default function Aanmelden(props) {
  const [rows, setRows] = useState([]);
  const aanmeldenRef = useRef(null);

  useEffect(() => {
    fetch("/lactatiekundigen.csv")
      .then(res => res.text())
      .then(text => {
        const parsed = Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
        });
        setRows(parsed.data);
      });
  }, []);

  const scrollToAanmelden = () => {
    if (aanmeldenRef.current) {
      aanmeldenRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Container 
        ref={props.parentRef} id='aanmelden' tabIndex="-1"
        style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      
      {/* WRAPPER MET ACHTERGROND + PADDING */}
      <div style={{ width: '100%', backgroundColor: 'var(--sand)', padding: '4rem 2rem', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2rem' }}>
        
        {/* TITEL + TOELICHTING */}
        <div style={{ maxWidth: '800px', textAlign: 'center' }}>
          <Typography type='h2' style={{ color: 'var(--trust)', marginBottom: '1rem' }}>
            Vind een lactatiekundige bij jou in de buurt 
          </Typography>
          
        </div>

        {/* KAART */}
        <MapContainer borderColor="white" style={{ width: '100%', maxWidth: '800px', height: 'auto', overflow: 'hidden' }}>
          <img
            src={zorgkaart}
            alt="Zorgkaart"
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              display: 'block',
              margin: '0 auto'
            }}
          />
        </MapContainer>

        {/* LIJST */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1rem',
            width: '100%',
            maxWidth: '800px'
          }}
        >
          {rows.map((row, i) => (
            <div
              key={i}
              style={{
                background: 'white',
                padding: '0.75rem 1rem',
                borderRadius: '8px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                border: '1px solid #eee'
              }}
            >
              <div>
                <Typography style={{ fontWeight: 600 }}>{row.bedrijf}</Typography>
                <Typography>{row.lactatiekundige}</Typography>
                <Typography style={{ fontSize: '0.9em' }}>
                  {row.straat}<br />
                  {row.postcode} {row.plaats}
                </Typography>
                {row.Website && (
                    <a
                    href={row.Website.startsWith('http') ? row.Website : `https://${row.Website}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    color: 'var(--trust)',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    }}
                    >
                    Ga naar →
                    </a>
                    )}
                
              </div>

            </div>
          ))}
        </div>

        
      </div>

    </Container>
  );
}